import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=1647bdcd&scoped=true&"
import script from "./Settings.vue?vue&type=script&setup=true&lang=js&"
export * from "./Settings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647bdcd",
  null
  
)

export default component.exports